import React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/**
 * Masked input enforcing ###.###.#### shape.
 * Hard-caps at 10 digits; formats with dots as the user types.
 * Reusable: consumers pass value/onChange/invalid.
 */
export default function PhoneInput({
  value = "",
  onChange,
  invalid = false,
  placeholder = "402.555.0142",
  className = "",
  ...rest
}) {
  const handle = (raw) => {
    const digits = (raw || "").replace(/\D/g, "").slice(0, 10);
    let out = digits;
    if (digits.length > 6) {
      out = `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    } else if (digits.length > 3) {
      out = `${digits.slice(0, 3)}.${digits.slice(3)}`;
    }
    onChange?.(out);
  };

  return (
    <Input
      type="tel"
      inputMode="numeric"
      value={value}
      onChange={(e) => handle(e.target.value)}
      placeholder={placeholder}
      className={cn(
        "h-12 rounded-full px-5",
        invalid && "border-destructive focus-visible:ring-destructive",
        className
      )}
      aria-invalid={invalid}
      {...rest}
    />
  );
}
